import { CSSProperties, memo } from "react";
import ListItem from "@mui/material/ListItem";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import IconButton from "@mui/material/IconButton";
import ButtonGroup from "@mui/material/ButtonGroup";
import Typography from "@mui/material/Typography";
import { useConfirm } from "material-ui-confirm";
import { StatusChip } from "shared";
import { Employee } from "entitites/employees/model/employee";
import { useNavigate } from "react-router-dom";
import { useDeleteEmployeeByIdMutation } from "entitites/employees/api/employeesApi";
import { useGetMyRolesQuery } from "entitites/casdoor/api/casdoorApi";

interface ItemProps {
  style: CSSProperties;
  data: Employee;
  width: number;
}

export const EmployeeItem = memo(function ({ style, data, width }: ItemProps) {
  const navigate = useNavigate();
  const confirm = useConfirm();
  const { data: roles } = useGetMyRolesQuery();
  const [deleteIt] = useDeleteEmployeeByIdMutation();
  return (
    <ListItem
      secondaryAction={
        !Boolean(roles?.includes("staffdesk-admin")) ? (
          <Button
            disableElevation
            variant="contained"
            size="small"
            onClick={() =>
              navigate(`edit/${data.id}/prof/${window.location.search}`)
            }
            sx={{
              textTransform: "none",

              ml: "auto",
              fontWeight: 700,
            }}
          >
            Открыть
          </Button>
        ) : (
          <ButtonGroup>
            <Button
              disableElevation
              variant="contained"
              size="small"
              onClick={() =>
                navigate(`edit/${data.id}/prof/${window.location.search}`)
              }
            >
              +
            </Button>
            <Button
              disableElevation
              variant="contained"
              size="small"
              onClick={() =>
                confirm({
                  title: `Точно удалить учётную запись ${data.fio}-${data.personalInfo.status.name}-${data.personalInfo.email}? Вернуть её и историю изменений будет невозможно`,
                  confirmationButtonProps: {
                    color: "error",
                    variant: "contained",
                  },
                  content: "Для удаления введите ниже ФИО-СТАТУС-ПОЧТА",
                  confirmationText: "Удалить",
                  confirmationKeyword: `${data.fio}-${data.personalInfo.status.name}-${data.personalInfo.email}`,
                  cancellationButtonProps: {
                    variant: "contained",
                    color: "success",
                  },
                })
                  .then(() =>
                    deleteIt(data.id).then(() => window.location.reload()),
                  )
                  .catch((err) => console.log(err))
              }
            >
              -
            </Button>
          </ButtonGroup>
        )
      }
      sx={{ ...style }}
      key={data.id}
      disablePadding
    >
      <Box
        display="flex"
        alignItems="center"
        p={1}
        px={2}
        sx={{
          ":hover": {
            bgcolor: "background.default",
          },
          transition: "ease-in-out 0.15s",
          width: width,
          gap: 2,
          height: "100%",
          borderRadius: "4px",
          cursor: "default",
        }}
      >
        <Box
          whiteSpace="nowrap"
          textOverflow="ellipsis"
          overflow="hidden"
          width={width * 0.15}
          maxWidth={width * 0.15}
          fontSize="14px"
        >
          {data.fio}
        </Box>
        <Box
          whiteSpace="nowrap"
          textOverflow="ellipsis"
          overflow="hidden"
          width={width * 0.1}
          maxWidth={width * 0.1}
        >
          <StatusChip
            title={data.personalInfo.status.name}
            color={data.personalInfo.status.color}
          />
        </Box>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexWrap="nowrap"
          height="45px"
          textOverflow="ellipsis"
          overflow="hidden"
          width={width * 0.25}
          maxWidth={width * 0.25}
          borderRadius="4px"
          bgcolor={data.profInfo.position.color}
          fontSize="14px"
          textAlign="center"
        >
          {data.profInfo.position.name}
        </Box>
        <Box
          width={width * 0.15}
          maxWidth={width * 0.15}
          borderRadius="4px"
          display="flex"
          alignItems="center"
        >
          <Typography
            whiteSpace="nowrap"
            textOverflow="ellipsis"
            overflow="hidden"
            fontSize="14px"
          >
            {data.personalInfo.email}
          </Typography>
          <IconButton
            sx={{ ml: "auto" }}
            onClick={() =>
              navigator.clipboard.writeText(data.personalInfo.email)
            }
            color="info"
            size="small"
          >
            <ContentCopyIcon />
          </IconButton>
        </Box>
        <Box
          width={width * 0.1}
          maxWidth={width * 0.1}
          borderRadius="4px"
          display="flex"
          alignItems="center"
          gap={1}
        >
          <Typography
            whiteSpace="nowrap"
            textOverflow="ellipsis"
            overflow="hidden"
            fontSize="14px"
          >
            {data.personalInfo.personalPhone}
          </Typography>
          <IconButton
            sx={{ ml: "auto" }}
            onClick={() =>
              navigator.clipboard.writeText(data.personalInfo.personalPhone)
            }
            color="info"
            size="small"
          >
            <ContentCopyIcon />
          </IconButton>
        </Box>
        <Box
          width={width * 0.1}
          maxWidth={width * 0.1}
          borderRadius="4px"
          display="flex"
          alignItems="center"
          gap={1}
        >
          <Typography
            whiteSpace="nowrap"
            textOverflow="ellipsis"
            overflow="hidden"
            fontSize="14px"
          >
            {data.personalInfo.telegram}
          </Typography>
          <IconButton
            onClick={() =>
              navigator.clipboard.writeText(data.personalInfo.telegram)
            }
            sx={{ ml: "auto" }}
            color="info"
            size="small"
          >
            <ContentCopyIcon />
          </IconButton>
        </Box>
      </Box>
    </ListItem>
  );
});
